import { createFileRoute, redirect } from "@tanstack/react-router";

// Short alias that has earned search rankings and backlinks (seen in Ahrefs as
// /Wheel). 301 it to the Wheel of Life assessment so the link equity follows.
export const Route = createFileRoute("/_public/wheel")({
  beforeLoad: () => {
    throw redirect({ to: "/wheel-of-life", statusCode: 301 });
  },
  component: () => null,
  staticData: { title: "Wheel of Life" },
});
